<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<div class="d-flex mt-3 ms-1 mb-2 justify-content-between align-items-center hidden-mobile">
  <h3>Corrispettivi (Scontrini)</h3>
  <div class="me-1 custom-select-wrapper year-select">
    <mat-form-field appearance="fill" subscriptSizing="dynamic">
      <mat-select
        class="izy-select-trigger"
        panelClass="izy-select-panel"
        [(value)]="selectedYear"
        (selectionChange)="onYearSelected($event)">
        <mat-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div class="w-100 mb-2 visible-mobile custom-rounded">
  <div class="custom-select-wrapper year-select">
    <mat-form-field appearance="fill" class="mb-0 w-100 custom-rounded" subscriptSizing="dynamic">
      <mat-select
        class="custom-rounded izy-select-trigger"
        panelClass="izy-select-panel"
        [(value)]="selectedYear"
        (selectionChange)="onYearSelected($event)">
        <mat-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<mat-accordion class="me-0 mb-3 col-md-12 d-flex flex-column">
  <mat-expansion-panel
    [(expanded)]="filterPanelOpenState"
    class="izy-fields izy-filter-panel izy-sharp-bl">
    <mat-expansion-panel-header class="izy-filter-header">
      <mat-panel-title class="izy-filter-title">
        <span class="izy-filter-icon">
          <mat-icon>filter_list</mat-icon>
        </span>
        <span class="ms-2">Filtri</span>
      </mat-panel-title>
      <mat-panel-description *ngIf="!filterPanelOpenState">
        <span
          class="izy-filter-count"
          [ngClass]="{'izy-filter-count--active': getActiveFilterCount() > 0}">
          {{ getActiveFilterCount() }} filtri attivi
        </span>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="row w-100">
      <div class="w-sm-50">
        <mat-form-field appearance="outline" floatLabel="always" class="w-100">
          <mat-label>Cerca per Matricola RT</mat-label>
          <input matInput [(ngModel)]="filters.device_id_icontains" name="device_id" />
          <mat-icon matSuffix>qr_code</mat-icon>
        </mat-form-field>
      </div>

      <div class="w-sm-25-mobile-25">
        <mat-form-field appearance="outline" floatLabel="always" class="w-100">
          <mat-label>Importo min.</mat-label>
          <input matInput type="number" [(ngModel)]="filters.amount_gt" />
          <span matTextPrefix>€&nbsp;</span>
        </mat-form-field>
      </div>
      <div class="w-sm-25-mobile-25">
        <mat-form-field appearance="outline" floatLabel="always" class="w-100">
          <mat-label>Importo max.</mat-label>
          <input matInput type="number" [(ngModel)]="filters.amount_lt" />
          <span matTextPrefix>€&nbsp;</span>
        </mat-form-field>
      </div>
    </div>

    <div class="row w-100 mt-2">
      <mat-form-field appearance="outline" class="w-sm-50">
        <mat-label>Data trasmissione da</mat-label>
        <input matInput [matDatepicker]="detStartPicker" [(ngModel)]="filters.transmission_date_after" />
        <mat-datepicker-toggle matSuffix [for]="detStartPicker"></mat-datepicker-toggle>
        <mat-datepicker #detStartPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline" class="w-sm-50">
        <mat-label>Data trasmissione a</mat-label>
        <input matInput [matDatepicker]="detEndPicker" [(ngModel)]="filters.transmission_date_before" />
        <mat-datepicker-toggle matSuffix [for]="detEndPicker"></mat-datepicker-toggle>
        <mat-datepicker #detEndPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="izy-filter-actions d-flex justify-content-end gap-2 mt-2 w-sm-100">
      <button
        mat-stroked-button
        class="izy-button-ghost izy-button-ghost--warn custom-button-border"
        (click)="resetFilters(); loadCorrispettivi(); detectChanges()">
        <mat-icon>clear</mat-icon> Cancella
      </button>
      <button
        matButton="filled"
        class="izy-button-primary custom-button-border"
        (click)="loadCorrispettivi(); detectChanges()">
        <mat-icon>search</mat-icon> Applica
      </button>
    </div>
  </mat-expansion-panel>
</mat-accordion>

<!-- <div class="mt-3 mb-3 d-flex justify-content-end align-items-center">
  <button mat-stroked-button (click)="downloadSummaryPdf()" class="ms-2 flex-shrink-0 hidden-mobile">
    <mat-icon>assessment</mat-icon> Report Mensile
  </button>

  <button mat-stroked-button (click)="navigateToUploadXML()" class="ms-2 flex-shrink-0 hidden-mobile">
    <mat-icon>upload_file</mat-icon> Importa XML RT
  </button>

  <button mat-raised-button color="primary" (click)="navigateToNewManualReceipt()" class="ms-2 flex-shrink-0 primary-button">
    <mat-icon>add</mat-icon> Nuovo Corrispettivo
  </button>
</div> -->

<!-- <div class="mt-3 mb-3 d-flex justify-content-between align-items-center"> -->
  <!-- Filter chips -->
  <!-- <mat-chip-set aria-label="Filter selection" class="flex-grow-1">
    <mat-chip-option
      *ngFor="let option of filterOptions"
      [value]="option.value"
      [selected]="selectedFilter === option.value"
      (click)="applyFilter(option.value)"
    >
      {{option.name}}
    </mat-chip-option>
  </mat-chip-set> -->
<!-- </div> -->

<!-- Remove the .row wrapper and use d-flex directly -->
<div class="mt-3 mb-3 d-flex justify-content-between align-items-center">

  <!-- chips -->
  <mat-chip-set aria-label="Filter selection" class="flex-grow-1 status-chip-set">
    <mat-chip-option
      >
      Tutti
    </mat-chip-option>
  </mat-chip-set>

  <div class="d-flex justify-content-end hidden-mobile">
    <button
      mat-stroked-button
      (click)="invoicingSummaryDownloadPdf()"
      class="ms-2 flex-shrink-0 hidden-mobile izy-button-ghost izy-button-ghost--info custom-button-border"
      style="max-width: 250px;"
    >
      <mat-icon>receipt</mat-icon>
      Situazione contabile
    </button>

    <button
      mat-stroked-button
      (click)="navigateToUploadXML()"
      class="ms-2 flex-shrink-0 izy-button-ghost izy-button-ghost--accent custom-button-border"
      style="width: 200px;"
    >
      <mat-icon>upload_file</mat-icon>
      Carica file XML
    </button>
  </div>
  <!-- Niente margine verticale qui: e' un flex item della riga con
       align-items-center, un mb-3 sposterebbe il pulsante rispetto alla chip. -->
  <div class="visible-mobile">
    <!-- mobile version  -->
    <button
      mat-stroked-button
      (click)="navigateToUploadXML()"
      class="w-100 flex-shrink-0 visible-mobile izy-button-ghost izy-button-ghost--accent custom-button-border"
    >
      <mat-icon>upload_file</mat-icon>
      Carica file XML
    </button>
  </div>
</div>

<mat-card class="mb-3 hidden-mobile total-card izy-sharp-bl">
  <div class="w-100 d-flex mt-2 mb-0 justify-content-between align-items-center">
    <h6 class="ms-3 mb-2">Totale volume d'affari {{ selectedYear }}:</h6>
    <div class="me-3 d-flex align-items-center">
      <button mat-stroked-button class="total-button mb-2" (click)="handleAmountInfoClick($event)">
        <mat-icon>info</mat-icon>
        <strong>{{ formatTableAmount(totalAmountThisYear) }}</strong>
      </button>
    </div>
  </div>
</mat-card>

<mat-card
  class="bulk-actions-toolbar mb-3 p-0 izy-sharp-bl custom-card-border"
  *ngIf="selection.selected.length > 0">
  <div class="d-flex align-items-center justify-content-between p-2">
    <div><span class="ms-3 fw-bold">{{ selection.selected.length }}</span> elementi selezionati</div>
    <div class="d-flex gap-2">
      <!-- <button mat-button (click)="bulkDownloadXml()"><mat-icon>download</mat-icon> Scarica XML</button> -->
      <button
        mat-stroked-button
        class="izy-button-ghost izy-button-ghost--warn custom-button-border"
        (click)="clearSelection()"><mat-icon>close</mat-icon> Annulla</button>
    </div>
  </div>
</mat-card>

<mat-card class="mb-3 mb-md-0 col-md-12 d-flex flex-column custom-card izy-sharp-bl hidden-mobile">
  <mat-card-content>
    <div *ngIf="isLoading" class="loading-container text-center py-5">
      <mat-progress-spinner diameter="50" mode="indeterminate" class="mx-auto"></mat-progress-spinner>
      <p class="mt-3">Caricamento corrispettivi...</p>
    </div>

    <!-- Show empty state when no data -->
    <div *ngIf="dataSource.filteredData.length === 0 && !isLoading" class="empty-state text-center py-5">
      <img 
        src="izy_image_5_small.png" 
        alt="Nessun cliente"
        class="empty-state-image mb-3"
        style="max-width: 300px; opacity: 1;"
      >
      <h4 class="text-muted">Ancora nessun dato registrato...</h4>
      <p class="text-muted">Passa più tardi!</p>
    </div>

    <table *ngIf="!isLoading && dataSource.data.length > 0" mat-table [dataSource]="dataSource" matSort class="w-100">
      
      <ng-container matColumnDef="selectAll">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox class="custom-checkbox" (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox class="custom-checkbox" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="detection_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Rilevazione</th>
        <td mat-cell *matCellDef="let element">{{ element.detection_date | date:'dd/MM/yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="transmission_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Data Trasmissione</th>
        <td mat-cell *matCellDef="let element">{{ element.transmission_date | date:'dd/MM/yyyy' }}</td>
      </ng-container>

      <ng-container matColumnDef="progressive_number">
        <th mat-header-cell *matHeaderCellDef>Progr.</th>
        <td mat-cell *matCellDef="let element">{{ element.progressive_number }}</td>
      </ng-container>

      <ng-container matColumnDef="device_id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Dispositivo RT</th>
        <td mat-cell *matCellDef="let element">{{ element.device_id }}</td>
      </ng-container>

      <ng-container matColumnDef="n_docs">
        <th mat-header-cell *matHeaderCellDef class="text-center">N. Doc</th>
        <td mat-cell *matCellDef="let element" class="text-center">{{ element.n_docs }}</td>
      </ng-container>

      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Totale Lordo</th>
        <td mat-cell *matCellDef="let element" class="amount-cell">{{ formatTableAmount(element.amount) }}</td>
      </ng-container>

      <ng-container matColumnDef="paid_cash">
        <th mat-header-cell *matHeaderCellDef>Pagato Contanti</th>
        <td mat-cell *matCellDef="let element">{{ formatTableAmount(element.paid_cash) }}</td>
      </ng-container>

      <ng-container matColumnDef="paid_electronic">
        <th mat-header-cell *matHeaderCellDef>Pagato Elettronico</th>
        <td mat-cell *matCellDef="let element">{{ formatTableAmount(element.paid_electronic) }}</td>
      </ng-container>

      <ng-container matColumnDef="Actions">
        <th mat-header-cell *matHeaderCellDef class="text-center">Azioni</th>
        <td mat-cell *matCellDef="let element" class="text-center">
          <button
            mat-icon-button
            class="izy-row-actions-btn"
            [matMenuTriggerFor]="menu"
            (click)="$event.stopPropagation()"
            aria-label="Altre azioni">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu" class="izy-menu-panel" xPosition="before">
            <button mat-menu-item (click)="onRowClick(element)" ><mat-icon>visibility</mat-icon> Dettagli XML</button>
            <!-- <button mat-menu-item  class="text-danger"><mat-icon color="warn">delete</mat-icon> Elimina</button> -->
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns;"
        (click)="onRowClick(row)"
        [matTooltip]="getRowTooltip(row)"
        matTooltipClass="row-summary-tooltip"
        matTooltipPosition="above"
        [matTooltipShowDelay]="showDelay.value"
        [matTooltipHideDelay]="hideDelay.value"
      ></tr>
    </table>

    <mat-paginator [pageSize]="20" [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons [selectConfig]="{ panelClass: 'izy-select-panel' }" class="hidden-mobile pt-2 pb-2"></mat-paginator>
  </mat-card-content>
</mat-card>

<div class="mobile-cards visible-mobile">
  <div *ngIf="isLoading" class="text-center py-5">
    <mat-progress-spinner diameter="40" mode="indeterminate" class="mx-auto"></mat-progress-spinner>
  </div>

  <!-- Empty state for mobile -->
  <div *ngIf="filteredCorrispettivi.length === 0 && !isLoading" class="empty-state text-center py-5">
    <img 
      src="izy_image_5_small.png" 
      alt="Nessun cliente"
      class="empty-state-image mb-3"
      style="max-width: 250px; opacity: 1;"
    >
    <h4 class="text-muted">Ancora nessun dato registrato...</h4>
      <p class="text-muted">Passa più tardi!</p>
  </div>

  <mat-card *ngFor="let item of filteredCorrispettivi" class="mb-2 izy-sharp-bl custom-card-border">
    <mat-card-content>
      <div class="d-flex justify-content-between align-items-start">
        <div>
          <h6 class="mb-0"><strong>Chiusura del {{ item.detection_date | date:'dd/MM/yyyy' }}</strong></h6>
          <small class="text-muted">RT: {{ item.device_id }}</small>
        </div>
        <div class="text-end">
          <h6 class="mb-0 primary-text"><strong>{{ formatTableAmount(item.amount) }}</strong></h6>
          <small class="text-muted">{{ item.n_docs }} scontrini</small>
        </div>
      </div>
    </mat-card-content>

    <div class="d-flex justify-content-between align-items-center receipt-card-footer">
      <span class="text-small">Progressivo: {{ item.progressive_number }}</span>
      <button mat-stroked-button size="small" (click)="onRowClick(item)" class="receipt-details-btn custom-button-border">
        Dettagli <mat-icon class="ms-1" style="font-size: 18px; width: 18px; height: 18px;">chevron_right</mat-icon>
      </button>
    </div>
  </mat-card>
</div>

<mat-card class="sticky-footer visible-mobile">
  <div class="w-100 d-flex p-2 justify-content-between align-items-center">
    <h6 class="m-0">Totale {{ selectedYear }}:</h6>
    <button mat-stroked-button class="total-button" (click)="handleAmountInfoClick($event)" matTooltip="Informazioni aggiuntive">
      <mat-icon>info</mat-icon>
      <strong>{{ formatTableAmount(totalAmountThisYear) }}</strong>
    </button>
  </div>
</mat-card>

<ng-template #amountInfoDialog let-dialogRef="dialogRef">
  <h2 mat-dialog-title class="m-0 pt-3 ps-3 d-flex align-items-center">
    <mat-icon class="me-2">info</mat-icon> 
    Dettagli Totale corrispettivi
  </h2>
  
  <mat-dialog-content class="pt-3">
    <p class="mb-2">
      Il <strong>totale corrispettivi</strong> rappresenta la somma di tutti gli scontrini emessi nell'anno selezionato.
    </p>
    <p class="mb-0">
      Nota: per i corrispettivi data di emissisone e di incasso coincidono, dato che si presume l'immediato saldo della cifra indicata.
      <!-- Per i contribuenti forfettari, inoltre, come nel tuo caso, L'iva non deve essere considerata. -->
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="pb-3 pe-3">
    <button
      mat-stroked-button
      (click)="invoicingSummaryDownloadPdf()"
      class="ms-2 mb-2 flex-shrink-0 izy-button-ghost izy-button-ghost--info custom-button-border"
      style="max-width: 250px;"
    >
      <mat-icon>receipt</mat-icon>
      Situazione contabile
    </button>

    <button
      matButton="filled"
      (click)="dialogRef.close()"
      class="mb-2 izy-button-primary custom-button-border">
      <mat-icon>check</mat-icon>
      Ok, capito
    </button>
  </mat-dialog-actions>
</ng-template>